import { PageData } from './../../shared/models/page-data';
import { Data } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { CnhiEiiTestComponent } from 'src/app/card-reader/cnhi-eii-test/cnhi-eii-test.component';
import { LabApi } from 'src/app/services/api-service/labs/lab-api';
import { EasyNotificationService } from 'src/app/services/easy-notification.service';
import { ConsoleInfo, CshisIni, HcrService, PaperSize } from 'src/app/services/hcr-service.service';
import { UserCache } from 'src/app/services/user-cache';
import { UserConfirmService } from 'src/app/services/user-confirm.service';
import { VisDialogComponent } from 'src/app/shared/components/dialog/vis-dialog/vis-dialog.component';
import { DateHelper } from 'src/app/shared/helpers/date-helper';
import { IcHelper } from 'src/app/shared/helpers/ic-helper';
import { Compare, verifyTaiwanIdIntermediateStringAndMsg } from 'src/app/shared/utilities';
import { MainLayoutService } from '../services/main-layout.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { VisionHIS6 } from 'src/app/shared/hcr-lib/VisionHIS6';
import { VisionHIS } from 'src/app/shared/hcr-lib/VisionHIS';
import { CalendarApi, CalendarCountDto } from 'src/app/services/api-service/calendar/calendar-api';
import { DentalHolidayCalendarCacheService } from 'src/app/services/dental-holiday-calendar-cache.service';
import { ConsoleApi, UserClient } from 'src/app/services/api-service/console-api.service';
import { SignalRService } from 'src/app/services/signalr-service';
import { SystemCmd } from 'src/app/services/signalr-event-handler/system-event-handler';
import { EasyFormService } from 'src/app/services/easy-form-service';
import { FormHelper, FormHelperService } from 'src/app/services/formhelper';
import { VisionHisDesc } from 'src/app/shared/hcr-lib/IVisionHis';
import { MineComponent } from '../extra/mine/mine.component';
import { SnackComponent } from '../extra/snack/snack.component';
import { PokerDeskComponent } from '../extra/poker/poker-desk/poker-desk.component';
import { HpcBhpService } from 'src/app/services/hpc-bhp.service';
import { GomokuComponent } from '../extra/gomoku/gomoku.component';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WebApiService } from 'src/app/services/web-api.service';
import { WebApiClient } from 'src/app/services/web-api-client.service';
import { Subject } from 'rxjs';
import { IEntity } from 'src/app/shared/models/i-entity';
import { takeUntil } from 'rxjs/operators';
import { BaseConfig } from 'src/app/services/base-config.service';
import { onGetDateString } from "src/app/shared/utilities";
import { FileUploadConfig, FileUploadSelected, FileUploadInsertKey } from 'src/app/shared/models/file-upload-selected';
import { FileService } from 'src/app/services/api-service/file/file.service';
import { ClinicDataService } from 'src/app/services/data-service/clinic-data-service';
import { DxOpt, RsOpt, RxOpt, userStat } from "src/app/services/api-service/hist/hist-edit-option";
import { LicenseApi } from 'src/app/services/api-service/LicenseApi';
import { debug } from 'console';
import { MainLayoutComponent } from 'src/app/layout/main-layout/main-layout.component';
import { ConfirmData } from 'src/app/services/user-confirm.service';
import { SystemSettingType } from './system-setting-export-import/system-setting-export-import.model';


@Component({
  selector: 'app-debug-tool',
  templateUrl: './debug-tool.component.html',
  styleUrls: ['./debug-tool.component.css']
})
export class DebugToolComponent<T extends IEntity> implements OnInit {

  queryFormGroup: FormGroup;
  api: WebApiService;


  //#region 變數
  private baseUnsubscribe: Subject<void> = new Subject();
  // 清單物件
  listItems: T[];
  // 表格-所選項目
  selectedItems: number[] = [];

  // 表格-分頁
  gridView: {
    data: T[],
    total:number
  };
  pageSize: number = BaseConfig.getConfig().ui.pageSize;
  pageSkipNo = 0;

  // 系統匯入匯出
  isOpenSystemSetting = false;
  systemSettingType: SystemSettingType;

  // 北極星掛號查詢 API 測試
  /** 測試視窗開關 */
  isPolarisDialogOpened = false;
  /** VisionCloud.WebApi 位址，依啟動 profile 不同：IIS Express 為 44340，dotnet run 為 5001 */
  polarisBaseUrl = 'https://localhost:44340';
  /** 授權金鑰，僅保留於記憶體，不持久化 */
  polarisKey = '';
  /** 查詢日期，格式 yyyy-MM-dd */
  polarisDdate = new Date().toISOString().slice(0, 10);
  /** 查詢起點，格式 HH:mm:ss */
  polarisFromTime = '00:00:00';
  /** 查詢終點，格式 HH:mm:ss */
  polarisToTime = '23:59:59';
  /** 查詢模式，incremental 或 full */
  polarisMode = 'full';
  /** 分頁游標。有下一頁時由回應自動填入，清空即從第一頁重查 */
  polarisCursor = '';
  /** 視窗內顯示的上次呼叫結果摘要 */
  polarisResultHint = '';

  // LineBot 診間資料查詢 API 測試
  /** 測試視窗開關 */
  isLineBotDialogOpened = false;
  /** VisionCloud.WebApi 位址，依啟動 profile 不同：IIS Express 為 44340，dotnet run 為 5001 */
  lineBotBaseUrl = 'https://localhost:44340';
  /** 授權金鑰，僅保留於記憶體，不持久化 */
  lineBotKey = '';
  /** 病歷號 */
  lineBotPatientNo = '';
  /** 身分證字號 */
  lineBotCId = '';
  /** 查詢筆數。空白時不帶此參數，由後端套用預設值 */
  lineBotCount = '';
  /** 視窗內顯示的上次呼叫結果摘要 */
  lineBotResultHint = '';

  constructor(
    private hcrService: HcrService,
    public confirmService: UserConfirmService,
    private notification: EasyNotificationService,
    private matDialog: MatDialog,
    private labApi:LabApi,
    private mainlayout:MainLayoutService,
    private httpClient:HttpClient,
    private calendarApi: CalendarApi,
    private dentalHolidayCalendar: DentalHolidayCalendarCacheService,
    private consoleApi:ConsoleApi,
    private sgR:SignalRService,
    private ezForm:EasyFormService,
    private fh:FormHelperService,
    private fb: FormBuilder,
    private webApiClient: WebApiClient,
    private fileService: FileService,
    private licenseApi: LicenseApi,
    private hpcbhp:HpcBhpService,
    private clinicData: ClinicDataService,
    private layout: MainLayoutComponent
  ) { }


  ngOnInit(): void {

    this.useWebApi = HcrService.useWebApi;
    this.clinicNhiCode = UserCache.getLoginUser().Clinic.NHICode;
    this.companyCode = UserCache.getLoginUser().CompanyCode;
    this.logDetailFh = this.fh.Create<LogDetailFilter>().build({
      etime:['',null],
      stime:['',null],
      keyword:['',null],
    })
  }

  //#region 北極星掛號查詢 API 測試
  /**
   * 呼叫北極星掛號查詢 API，結果輸出至 console。
   *
   * 直接使用 HttpClient 而非 WebApiService，因後者會附加 Authorization 標頭，
   * 與 XDevMiddleWare 寫入的同名標頭衝突而使請求在進入 API 前失敗。
   *
   * HttpErrorInterceptor 會改寫錯誤內容，401 與 500 的原始 error.code 不會出現在 console，
   * 需自 DevTools 的 Network 分頁檢視原始回應。
   */
  testPolarisRegister() {
    if (!this.polarisKey) {
      this.polarisResultHint = '請輸入 X-DEV 金鑰';
      return;
    }

    const loginUser = UserCache.getLoginUser();
    const url = `${this.polarisBaseUrl.replace(/\/$/, '')}/api/Polaris/Register/GetRegister`;
    const body = {
      ddate: this.polarisDdate,
      from_time: this.polarisFromTime,
      to_time: this.polarisToTime,
      mode: this.polarisMode,
      timezone: 'Asia/Taipei',
      cursor: this.polarisCursor || null
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'X-DEV': this.polarisKey,
      'CompanyCode': loginUser.CompanyCode,
      'ClinicCode': loginUser.Clinic?.Code ?? ''
    });

    this.polarisResultHint = '查詢中';
    this.httpClient.post<any>(url, body, { headers }).subscribe({
      next: r => {
        const data = r?.data;
        // 回填游標，再按一次即取下一頁；無下一頁時清空，下次從第一頁重查
        this.polarisCursor = data?.next_cursor ?? '';
        this.polarisResultHint =
          `成功 筆數=${data?.records?.length ?? 0} has_more=${data?.has_more}`;
        console.log(`[Polaris] ${this.polarisResultHint}`, r);
      },
      error: e => {
        this.polarisResultHint = `失敗 HTTP ${e?.status}，詳見 Network 分頁`;
        console.log('[Polaris] 失敗', e);
      }
    });
  }
  //#endregion

  //#region LineBot 診間資料查詢 API 測試
  /**
   * 呼叫 LineBot 診間資料查詢 API，結果輸出至 console。
   *
   * 直接使用 HttpClient 而非 WebApiService，原因同 testPolarisRegister。
   * 病歷號與身分證刻意不在前端擋空值，以便驗證後端的 MISSING_PARAM。
   * HttpErrorInterceptor 可能改寫錯誤內容，原始回應需自 DevTools 的 Network 分頁檢視。
   */
  testLineBotRecord() {
    if (!this.lineBotKey) {
      this.lineBotResultHint = '請輸入 X-DEV 金鑰';
      return;
    }

    const loginUser = UserCache.getLoginUser();
    const url = `${this.lineBotBaseUrl.replace(/\/$/, '')}/api/LineBot/Record/GetRecord`;
    let params = new HttpParams()
      .set('PatientNo', this.lineBotPatientNo ?? '')
      .set('CId', this.lineBotCId ?? '');
    if (this.lineBotCount?.trim()) {
      params = params.set('Count', this.lineBotCount.trim());
    }
    const headers = new HttpHeaders({
      'X-DEV': this.lineBotKey,
      'CompanyCode': loginUser.CompanyCode,
      'ClinicCode': loginUser.Clinic?.Code ?? ''
    });

    this.lineBotResultHint = '查詢中';
    this.httpClient.get<any>(url, { headers, params }).subscribe({
      next: r => {
        const data = r?.data;
        this.lineBotResultHint =
          `成功 病患=${data?.Patient ? '有' : '無'} 掛號筆數=${data?.Registers?.length ?? 0}`;
        console.log(`[LineBot] ${this.lineBotResultHint}`, r);
      },
      error: e => {
        const code = e?.error?.error?.code ?? e?.error?.Code;
        this.lineBotResultHint = `失敗 HTTP ${e?.status}${code ? ` ${code}` : ''}，詳見 Network 分頁`;
        console.log('[LineBot] 失敗', e);
      }
    });
  }
  //#endregion

  //#region 虛擬健保卡
  // vhcStatus: string = '';
  // async onQRCodeScanResult(code: string, dialog: VisDialogComponent) {
  //   dialog.show = false;
  //   var ret = await this.hcrService.VHCApi.uploadqrcode(code)
  //   if (ret.StatusCode != 0) {
  //     this.notification.showError(ret.ErrorMsg);
  //   } else {
  //     this.notification.showSuccess(ret.ErrorMsg);
  //   }
  //   var cardStatus = await this.hcrService.VHCApi.GetCardStatusHC();
  //   this.vhcStatus = cardStatus.Data;
  //   console.log(code)
  // }
  // async clearVHC() {
  //   var ret = await this.hcrService.VHCApi.cleanQRCode()
  //   if (ret.StatusCode != 0) {
  //     this.notification.showError(ret.ErrorMsg);
  //   } else {
  //     this.notification.showSuccess(ret.ErrorMsg);
  //   }
  // }
  // async VHCStatus() {
  //   var ret = await this.hcrService.VHCApi.GetCardStatusHC()
  //   this.confirmService.showAlert("結果", JSON.stringify(ret));
  // }
  // async VHCBasic() {
  //   var ret = await this.hcrService.VHCApi.GetBasicData()
  //   this.confirmService.showAlert("結果", JSON.stringify(ret));
  // }
  // async VHCRegBasic() {
  //   var ret = await this.hcrService.VHCApi.GetRegisterBasic()
  //   this.confirmService.showAlert("結果", JSON.stringify(ret));
  // }
  // async VHCTreat() {
  //   var ret = await this.hcrService.VHCApi.GetTreatmentNoNeedHPC()
  //   console.log(ret);
  //   var ret2 = await this.hcrService.VHCApi.QuickInsurence('')
  //   console.log(ret2);
  //   this.confirmService.showAlert("結果", JSON.stringify(ret) + '\n\n' + JSON.stringify(ret2));
  // }
  // // 需醫師卡
  // async VHCTreat2() {
  //   var ret = await this.hcrService.VHCApi.GetTreatmentNeedHPC()
  //   console.log(ret);
  //   var ret2 = await this.hcrService.VHCApi.ReadPrescription();
  //   console.log(ret2);
  //   this.confirmService.showAlert("結果", JSON.stringify(ret) + '\n\n' + JSON.stringify(ret2));
  // }
  // async VHCIsq() {
  //   var ret = await this.hcrService.VHCApi.GetLastSeqNum()
  //   console.log(ret);
  //   this.confirmService.showAlert("結果", JSON.stringify(ret));
  // }
  //#endregion
  //#region api測試

  cnhieiiTest(evt) {
    var diag = this.matDialog.open(CnhiEiiTestComponent, {
      disableClose: true,
      panelClass: 'CnhiEiiTestWidth',
      width: '95%',
      maxWidth: '95vw'
    });
    diag.componentInstance.onClose.subscribe(x => diag.close());
    //this.cnhi_eii.GetHospType
  }
  async dayliUploadTest(evt) {
    var file = await this.hcrService.SelectFiles()
    var ret = await this.hcrService.VisionApi.UploadData(file.FullName, "60");
    if (ret.StatusCode == 0) {
      if (ret.Data) {
        await this.confirmService.showAlert('執行成功',
          '醫事服務機構代碼: \t' + ret.Data.HospId + '\n' +
          '上傳日期時間: \t' + ret.Data.UploadDateTime + '\n' +
          '接收日期時間: \t' + ret.Data.RecieveDateTime + '\n' +
          'DC接收檔案筆數: \t' + ret.Data.RecieveNumber + '\n' +
          'DC接收檔案大小: \t' + ret.Data.RecieveSize + ' (Byte)\n' +
          '安全模組代碼: \t' + ret.Data.SAMId + '\n', { 'fitContent': true }
        );
      } else {
        this.notification.showSuccess('執行成功');
      }
    } else {
      this.notification.showError(ret.ErrorMsg);
    }
  }

  async referalDownloadTest(evt){
    var file = await this.hcrService.SelectFiles()
    var ret = await this.hcrService.VisionApi.CNHIEiiDownload(0,'10',file.FullName);
    if(ret.StatusCode==0){
      if(ret.Data){
        await this.confirmService.showAlert('執行成功',
        'LocalID: \t'+ ret.Data.LocalID+'\n'+
        'NHIID: \t'+ ret.Data.NHIID+'\n',{'fitContent':true}
        );
      }else{
        this.notification.showSuccess('執行成功');
      }
    }else{
      this.notification.showError(ret.ErrorMsg);
    }
  }
  //#endregion
  //#region 就醫識別碼 webapi切換
  useWebApi: boolean;
  useWebApiChecked(evt: MatCheckboxChange) {
    HcrService.useWebApi = evt.checked;
  }
  //#endregion

  //#region  就醫識別碼模擬
  treat_hinno: string = '';
  treat_dt: Date = new Date();
  treat_tm: string = '';
  treat_cid: string = '';
  treat_no: string = '';
  async TestITreat() {
    //var a = new VisionHisDemo(null);
    //3532018235
    //HTU4AY G21LNZC 3AF1D3W
    //this.getTreatId('7431110698','G221489822',new Date(2023,7,21,15,11,44))
    this.treat_no = '';
    var dt = new Date(this.treat_dt.toLocaleDateString() + ' ' + this.treat_tm)
    this.treat_no = this.getTreatId(this.treat_hinno, this.treat_cid, dt)
    console.log('目標：HTU4AYG21LNZC3AF1D3W')

    //this.getTreatInfo(this.treat_no);
  }
  ParseTreat() {
    this.getTreatInfo(this.treat_no);
  }
  ClearTreat() {
    this.treat_hinno = '';
    this.treat_dt = new Date();
    this.treat_tm = '';
    this.treat_cid = '';
    this.treat_no = '';
  }
  private getITreatString(n: number) {
    var char = '0123456789ABCDEFGHJKLMNPQRSTUVWXYZ';
    var calcTemp = Math.floor(n);
    var treatIdBuild = ''
    do {
      var a = calcTemp % char.length;
      treatIdBuild = char[a] + treatIdBuild;
      calcTemp = Math.floor(calcTemp / char.length)
    }
    while (calcTemp > 0)
    return treatIdBuild;
  }
  private getITreatNum(s: string) {
    var char = '0123456789ABCDEFGHJKLMNPQRSTUVWXYZ';
    var n = 0;
    for (let c of s) {
      var i = char.indexOf(c);
      n *= char.length
      n += i;
    }

    return n;
  }
  /** 第一欄請自行複製6碼 */
  public getTreatId(nhiCode: string, cid: string, dt: Date) {
    //機構代馬 (6)
    var c1 = nhiCode;// this.getITreatString(parseInt(nhiCode));
    // 身分證 前2馬保留
    var cCid1 = cid.substring(0, 2)
    // 身分證 3-9碼 轉成5碼 (身分證檢查碼跳過)
    var code = cid.substring(2, 9)
    var cCid2 = this.getITreatString(parseInt(code));
    // 年份 2碼
    var cYr = this.getITreatString(dt.getFullYear() - 1911);
    // 時間5碼
    var secDiff = (dt.getTime() - new Date(dt.getFullYear(), 0, 1, 0, 0, 0).getTime()) / 1000
    var cDt = this.getITreatString(secDiff).padStart(5, '0');

    console.log('轉換：', nhiCode, cid, dt)
    console.log('結果：' + c1 + cCid1 + cCid2 + cYr + cDt);
    return c1 + cCid1 + cCid2 + cYr + cDt;
  }
  public getTreatInfo(treatNo: string) {
    //機構代馬 (6)
    var c1 = treatNo.substring(0, 6);// this.getITreatString(parseInt(nhiCode));
    // 身分證 前2馬保留
    var cCid1 = treatNo.substring(6, 8)
    // 身分證 3-9碼 轉成5碼 (身分證檢查碼跳過)
    var code = treatNo.substring(8, 13)
    var cCid2 = this.getITreatNum(code);
    var cid = `${cCid1}${cCid2}0`;
    var cCid3 = verifyTaiwanIdIntermediateStringAndMsg(cid, true).validateNum; // 身分證驗證碼
    var cid = `${cCid1}${cCid2}${cCid3}`;
    // 年份 2碼
    var cYr = this.getITreatNum(treatNo.substring(13, 15));
    // 時間5碼
    var cSec = this.getITreatNum(treatNo.substring(15, 20))
    var dt = new Date(new Date(cYr + 1911, 0, 1, 0, 0, 0).getTime() + cSec * 1000);

    this.treat_hinno = c1;
    this.treat_cid = cid;
    this.treat_dt = dt;
    this.treat_tm = DateHelper.getTimeString(dt, ':')
    console.log('結果：' + cid + ', ' + dt);

  }
  //#endregion

  //#region 檢驗
  labPatientCId = '';
  async CreateFakeResult(){
    try{
      await this.labApi.CreateFakeResult();
      this.notification.showSuccess('造假完成');
    }catch(e){
      this.notification.showError(e);
    }
  }
  clinicNhiCode:string;
  companyCode:string;
  labImportSt:Date = new Date();
  labImportEd:Date = new Date();
  async importLabFrom(){
    try{
      this.mainlayout.showLoader()
      var ret = await this.labApi.ImportLabFrom(this.companyCode,this.clinicNhiCode,this.labImportSt,this.labImportEd,this.labPatientCId)
      this.mainlayout.hideLoader()
      await this.confirmService.showAlert('匯入結果', `新取得 ${ret.ImportCount} 筆匯入資料。\n更新 ${ret.LabForms.length} 筆檢驗報告。`)
    }catch(e){
      this.notification.showError(e);
      this.mainlayout.hideLoader()
    }

  }
  //#endregion
  //#region CSHIS6
    async CSHIS6Open(){
      var ret = await this.confirmService.showConfirm({
        title:'體驗CSHIS6',
        msg:'是否開始使用主控台元件6.0版，若同意後請允許ciet6001s01應用程式執行'
      })
      if(ret){
        window.open('cshis6://console');
        //await this.hcrService.SendFromUrl('cshis6://console','','','',{});
      }
    }
    async CSHIS6Console(){
      window.open('https://localhost:5066/');
    }
    async CSHIS6Init(){
      var cshis6 = new VisionHIS6(this.hcrService,this.httpClient);
      var ret = await cshis6.Initial();
      if(ret.statusCode == 0 || ret.statusCode == 1001){
        this.hcrService.setVisionApi(cshis6);
        this.notification.showError('已切換至CSHIS6.0 API');
      }else{
        this.notification.showError('失敗~' + ret.statusCode);
      }
    }
    async CSHIS6Close(){
      var cshis6 = this.hcrService.VisionApi as VisionHIS6;
      var ret = await cshis6?.Finalize()
      if(ret.statusCode == 0){
        this.hcrService.setVisionApi(new VisionHIS(this.hcrService));
        this.notification.showError('已切換至5157API');
      }else{
        this.notification.showError('失敗~' + ret.statusCode);
      }
    }
  //#endregion

  //#region 政府公開資料
  isImportCalendarOpened = false;
  nowRocYear: number;
  importCalendarRocYear: number;
  calendarCount: CalendarCountDto[] = [];
  calendarCountHint: string = '';
  defaultRocYear() {
    var today = DateHelper.today;
    return today.getFullYear() - 1911 + (today.getMonth() >= 10 ? 1 : 0);
  }

  async ImportCalendarOpen() {
    if (!this.nowRocYear) {
      this.nowRocYear = DateHelper.today.getFullYear() - 1911;
    }
    if (!this.importCalendarRocYear) {
      this.importCalendarRocYear = this.defaultRocYear();
    }

    this.calendarCount = await this.calendarApi.CountCalendar(0);
    this.calendarCountHint = this.showCalendarCountHint();

    this.isImportCalendarOpened = true
  }

  async ImportCalendar() {
    if (this.importCalendarRocYear < 112 || this.importCalendarRocYear > 199) {
      this.notification.showError("民國年必須輸入112~199。");
      this.importCalendarRocYear = this.defaultRocYear();
      return;
    }

    var ret = await this.confirmService.showConfirm({
      msg: `是否確定匯入${this.importCalendarRocYear}年日曆?`
    });
    if (!ret) {
      return;
    }

    try {
      let year = this.importCalendarRocYear + 1911;
      let result = await this.calendarApi.ImportCalendar(year);
      CalendarApi
      if (result.IsSuccess) {
        const calendarRefreshed = await this.dentalHolidayCalendar.refreshYear(year);
        this.isImportCalendarOpened = false;
        this.notification.showSuccess('匯入完成。共 ' + result.Object + ' 筆');
        if (!calendarRefreshed) {
          this.notification.showError('日曆已匯入，但本機快取更新失敗。');
        }
      } else {
        this.notification.showError('匯入失敗');
      }
    } catch (ex) {
      this.notification.showError(ex.message);
    }
  }

  showCalendarCountHint(): string {
    var item = this.calendarCount.find(x => x.Year == this.importCalendarRocYear + 1911);
    if (item) {
      var showLastTime = item.LastEditTime ?
          DateHelper.getROCFullDateString(new Date(item.LastEditTime), '/') + ' ' + DateHelper.getTimeString(item.LastEditTime, ':', true) :
          '無';
      return `${this.importCalendarRocYear}年, 已轉入 ${item.YearCount} 筆, 上次轉入時間 ${showLastTime}`;
    } else {
      return '尚未轉入';
    }
  }

  async CalendarRocYearChange() {
    this.calendarCountHint = this.showCalendarCountHint();
  }
  //#endregion
  users:UserClient[];
  hide7day = true;
  showAllUser = false;
  async reloadCurrentUser(){
    var u = await this.consoleApi.CurrentClients(!this.showAllUser);
    if(this.hide7day){
      u = u.filter(x=>
        new Date(x.LastAlifeDatetime) > DateHelper.addDay(new Date(),-7)
        // 要保留失聯但是有licensekey的
        || (!x.ConnectionId && !!x.LicenseKey)
      );
    }
    u.forEach(x=>x.ComputerName = decodeURIComponent(x.ComputerName))
    this.users = u.sort((a,b)=>(Compare(a.ConsoleConnected,b.ConsoleConnected)*-1)|| (Compare(new Date(a.LastAlifeDatetime),new Date(b.LastAlifeDatetime))*-1));
  }
  async uploadLog(user:UserClient){
    var region = await this.ezForm.show({
      title:'上傳紀錄',
      msg:'請選擇起訖區間',
      fields:{
        SDate:{
          type:'date',
          label:'起始',
          name:'SDate',
          value: new Date()
        },
        EDate:{
          type:'date',
          label:'結束',
          name:'EDate',
          value:new Date()
        }
      }, closeValue:(x)=>null
    });
    if(region){
      await this.sgR.SendCommand(user.ConnectionId,SystemCmd.UploadLog,region,`紀錄上傳${user.UserName}完成`);
    }
  }
  logFiles:string[] = []
  logFilesFiltered:{path:string,name:string}[] = []
  showLogList = false;
  showLogDetail = false;
  filterKey:string = '';
  logDetails:LogDetail[];
   logDetailsFiltered:LogDetail[];
   logDetailFh:FormHelper<LogDetailFilter>
  async getLogs(user:UserClient){
    this.logFilesFiltered = [];
    this.logFiles = await this.consoleApi.GetLogs(user.ClinicId,user.ComputerName);
    this.filterLog(this.filterKey);
    this.showLogList = true;
  }
  filterLog(keyword:string){
    this.filterKey = keyword;
    this.logFilesFiltered = this.logFiles.filter(x=>x.includes(this.filterKey)).map(x=>{
      var z = x.split('/');
      return {path:x,name:z[z.length-1]}
    })
  }
  async download(path:string){
    window.open(path);
  }
  canView(path:string){
    return path.endsWith('.log');
  }
  async view(path:string){
    if(!path.endsWith('.log')){
      return;
    }
    var response = await this.httpClient.get(path,{responseType:'arraybuffer'} ).toPromise<ArrayBuffer>()

    const decoder = new TextDecoder('utf-8');
    const fileContent = decoder.decode(response);
    this.logDetailFh.clear();
    this.logDetails = fileContent.split('\n').filter(x=>x).map(x=>{
      var a = x.split('\t').filter(x=>x);
      return {
       date: a[0].split(' ')[0],
       time: a[0].split(' ')[1],
       type: a[1],
       st  : a[2],
       msg : a.slice(3).join('\t'),
      }
    });
    this.filterLogDetail();
    this.showLogDetail = true;
  }
  filterLogDetail(){
    this.logDetailsFiltered = this.logDetails.filter(x=>{
      var ret = true;
      if(this.logDetailFh.Value.stime){
        ret &&= x.time >= (this.logDetailFh.Value.stime.split(':').map(x=>x.padStart(2,'0')).join(':') + '.000');
      }
      if(this.logDetailFh.Value.etime){
        ret &&= x.time <= (this.logDetailFh.Value.etime.split(':').map(x=>x.padStart(2,'0')).join(':') + '.000');
      }

      if(this.logDetailFh.Value.keyword){
        ret &&= x.msg.toLocaleLowerCase().includes(this.logDetailFh.Value.keyword.toLocaleLowerCase());
      }
      return ret;
    });
  }
  async viewDetailMsg(msg:string){

    var m = msg.replace('Websocket recieve user message: ','')
    var j:{ Call: string, call: string, Args: object,args:object} = JSON.parse(m);
    var a = j.Args||j.Args;
    //var s = Object.keys(a).map(x=>(`  ${x}=${JSON.stringify(a[x])}`)).join('\n');
    var show = `指令：${j.Call||j.call}\n參數：\n${this.getObjectDesc(a)}`
    this.confirmService.showAlert('訊息',show,{width:800});
  }
  getObjectDesc(o){
    var r = o.toString();
    if(typeof(o) == 'string'){
      return r;
    }
    r ='\n'+ Object.keys(o).map(x=>(`  ${x}=${this.getObjectDesc(o[x])}`)).join('\n');
    return r;
  }
  async update(user:UserClient){
    await this.sgR.SendCommand(user.ConnectionId,SystemCmd.UpdateConsole,{
      Commander:UserCache.getLoginUser().Account,
      NeedAllow:true
    },`${user.UserName}執行主控台更新結果...`);
  }
  consoleInfo:ConsoleInfo = null;
  paperSizeGrid:{PaperName:string,Width:number,Height:number}[] = [];
  showConsoleInfo = false;
  async getConsoleInfo(user:UserClient){
    try{
      this.consoleInfo = await this.consoleApi.GetConsoleInfo(user.ClinicCode,user.ComputerName);
      this.showConsoleInfo = true;
    }catch(e){
      this.notification.showWarning('查無此設備資訊')
    }
    //await this.confirmService.showAlert('結果',JSON.stringify(result));
  }
  async showConfig(){
    await this.confirmService.showAlert('結果',JSON.stringify(this.consoleInfo.Config));
  }
  async showPrint(){
    await this.confirmService.showAlert('結果',JSON.stringify(this.consoleInfo.Printers));
  }
  keys(o){
    return Object.keys(o);
  }
  switchPrinter(name:string){
    this.paperSizeGrid = this.consoleInfo.Printers[name].sort((a,b)=>Compare(a.PaperName,b.PaperName));
  }
  recentOnlineStyle(data:UserClient){
    return {color: DateHelper.addMinute(new Date(data.LastAlifeDatetime),10)>new Date()?'red':'black'}
  }
  visionHisDesc = new VisionHisDesc();
  playCard(){
    var cards = 0;
    var int = setInterval(()=>{
      var symbol = ['♠','♡','♢','♣']
      var no = ['A','2','3','4','5','6','7','8','9','10','J','Q','K']
      var card = symbol[Math.floor(Math.random()*symbol.length)]+no[Math.floor(Math.random()*no.length)]
      this.notification.showError('🂠'+card+'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA',false,()=>{
        this.confirmService.showAlert('翻開',card);
      })
      cards++;
      if(cards>=10){
        clearInterval(int);
      }
    },200)

  }
  randCard(){
    this.mainlayout.mainlayoutComp.洗牌()
  }
  @ViewChild('mine')
  mine:MineComponent;
  openMine(){
    this.mine.open();
  }
  @ViewChild('poker')
  poker:PokerDeskComponent;
  openPoker(){
    this.poker.open();
  }
  @ViewChild('gomoku')
  gomoku:GomokuComponent;
  openGomoku(){
    this.gomoku.open();
  }
  @ViewChild('snack')
  snack:SnackComponent;
  openSnack(){
    this.snack.open();
  }
  async tokenTest(){
    var ret = await this.hpcbhp.query成();
    console.log(ret);

  }


  //#region 藥品.套餐.主訴.服法.資料匯出匯入(DEMO轉正式用)






  //這四個負責選擇是否需要呼叫API、顯示列表、匯出選擇
  Rx: boolean = false;
  MainSet: boolean = false;
  CC: boolean = false;
  Dosage: boolean= false;
  //get回傳資料
  RxData: any;
  MainSetData: any;
  CCData: any;
  DosageData: any;
  //匯出資料本身
  ExPortRxData: T;
  ExPortMainSetData: T;
  ExPortSystemCodeData: T;
  ExPortDosageData: T;
  //匯入資料本身
  ImportRxData: any;
  ImportMainSetData: any;
  ImportCCData: any;
  ImportDosageData: any;
  //匯入資料分頁
  ImportRxDataView: RxDataResponse;
  ImportMainSetDataView: ShowImportMainSet;
  ImportCCDataView: SystemCodeDataResponse;
  ImportDosageDataView: DosageDataResponse;
  //快取資料
  CachedRxData: RxOpt[];
  CachedMainSetData: RsOpt[];
  //匯入回饋string
  PostDosage: string
  PostRx: string
  PostMainSet: string
  PostSystemCode: string

  ShowImportMainSet: ShowImportMainSetData[];//紀錄MainSet匯入改變
  ShowExportMainSet: ShowExportMainSet;//匯出預覽用
  ShowImportRx: RxItem[];

  WhichTableShow = -1; //選擇顯示哪個表格
  WhichImporTableShow = -1; //選擇顯示哪個表格
  showBtnGroup: boolean = false;//控制搜索後才顯示表格按鈕
  showImportBtnGroup: boolean = false;//控制匯入後才顯示表格按鈕
  isFileUploadDialogOpened: boolean = false;//匯入視窗開關控制
  openPushDialog: boolean = false;//匯入視窗資料表預覽視窗控制


  GetRx(pageSize?: number ,pageSkipNo?: number){
    this.queryFormGroup = this.fb.group({
      pageSize: pageSize,
      pageSkip: pageSkipNo,
    });
    //查詢參數
    const query = this.queryFormGroup.value;

    this.api.get("GetRx", query).pipe(takeUntil(this.baseUnsubscribe)).subscribe(
            (result: any) => {
        if(!pageSize){
          this.ExPortRxData = result.data;
        }else{
          this.RxData = result;
        }
      },
        error => this.notification.showGetDataFailed('RxData') // 失敗訊息
      );
  }

  GetMainSet(pageSize?: number ,pageSkipNo?: number){
    this.queryFormGroup = this.fb.group({
      pageSize: pageSize,
      pageSkip: pageSkipNo,
    });
    //查詢參數
    const query = this.queryFormGroup.value;

    this.api.get("GetMainSet", query).pipe(takeUntil(this.baseUnsubscribe)).subscribe(
            (result: any) => {
        if(!pageSize){
          this.ExPortMainSetData = result.data;
        }else{
          this.MainSetData = result;
          this.ShowExportMainSet = {
            pageNumber: this.MainSetData.pageNumber, pageSize: this.MainSetData.pageSize, total: this.MainSetData.total, totalPages: this.MainSetData.totalPages,
            data: this.MainSetData.data.map(element => ({
            Code: element.Code,
            DxApplyCode: element.DxApplyCode?.filter(x => x.trim() !== '').join(', ') ?? '',
            RxSetList: element.RxSetList.map(r => r.RxCode).filter(x => x && x.trim() !== '').join(',')
            }))
          }
        }
      },
        error => this.notification.showGetDataFailed('MainSetData') // 失敗訊息
      );
  }

  GetSystemCode(pageSize?: number ,pageSkipNo?: number){
    this.queryFormGroup = this.fb.group({
      pageSize: pageSize ?? null,
      pageSkip: pageSkipNo ?? null,
    })
    //查詢參數
    const query = this.queryFormGroup.value;

    this.api.get('GetSystemCode', query).pipe(takeUntil(this.baseUnsubscribe)).subscribe(
            (result: any) => {
        if(!pageSize){
          this.ExPortSystemCodeData = result.data;
        }else{
          this.CCData = result;
        }
      },
        error => this.notification.showGetDataFailed('CCData') // 失敗訊息
      );
  }

  GetDosage(pageSize?: number ,pageSkipNo?: number){
    this.queryFormGroup = this.fb.group({
      pageSize: pageSize ?? null,
      pageSkip: pageSkipNo ?? null,
    })
    //查詢參數
    const query = this.queryFormGroup.value;

    this.api.get("GetDosage", query).pipe(takeUntil(this.baseUnsubscribe)).subscribe(
          (result: any) => {
        if(!pageSize){
          this.ExPortDosageData = result.data;
        }else{
          this.DosageData = result;
        }
    },
      error => this.notification.showGetDataFailed('Dosage') // 失敗訊息
    )
  }



  onBtnQueryPullClick(){
    this.api = this.webApiClient.createHisService('DebugTool');
    //初始渲染選擇
    if(this.Rx){
      this.WhichTableShow = 0;
      this.GetRx(10,0);
    }else if(this.MainSet){
      this.WhichTableShow = 1;
      this.GetMainSet(10,0);
    }else if(this.CC){
      this.WhichTableShow = 2;
      this.GetSystemCode(10,0);
    }else if(this.Dosage){
      this.WhichTableShow = 3;
      this.GetDosage(10,0);
    }

    this.showBtnGroup = true;//顯示表格按鈕

  }

  //匯出按鈕
  onBtnExportClick1(){
    this.queryFormGroup = this.fb.group({
      pageSize: null,
      pageSkip: null,
    })
    const query = this.queryFormGroup.value;

    this.mainlayout.showLoader();
    let folder = "下載";
    let fileName = UserCache.getLoginUser().Clinic.Id + "_匯出資料" + onGetDateString(new Date(), false, '', false) + DateHelper.getTimeString(new Date(), '', true) + '.json';
    //編組匯出資料
    const exportDate :any= {
      customerCode: "匯出資料",
      exportTime: new Date().toISOString(),
      data:{}
    }
    if (this.RxData && this.Rx){
      exportDate.data.RxData = this.ExPortRxData;
    }
    if (this.MainSetData && this.MainSet){
      exportDate.data.MainSetData = this.ExPortMainSetData;
    }
    if (this.CCData && this.CC){
      exportDate.data.CCData = this.ExPortSystemCodeData;
    }
    if (this.DosageData && this.Dosage){
      exportDate.data.DosageData = this.ExPortDosageData;
    }

    const jsonExportDate = JSON.stringify(exportDate, null, 2);
    const blob = new Blob([jsonExportDate], { type: 'application/json;charset=utf-8' });
    this.hcrService.SaveBlobAs(folder + "\\" + fileName, blob);

    this.mainlayout.hideLoader();

  }

  async onBtnExportClick() {

    this.api = this.webApiClient.createHisService('DebugTool');

    if (!this.Rx && !this.MainSet && !this.CC && !this.Dosage) {
      this.notification.showWarning('請選擇要匯出的資料表');
      return;
    }

    this.mainlayout.showLoader();

    try {

      const exportData: any = {
      customerCode: UserCache.getLoginUser().Clinic.Id,
      exportTime: new Date().toISOString(),
      data: {}
      };

      if (this.Rx) {
        exportData.data.RxData =
          await this.api.get('ExportRxAll', {}).toPromise();
      }

      if (this.MainSet) {
        exportData.data.MainSetData =
          await this.api.get('ExportMainSetAll', {}).toPromise();
      }

      if (this.CC) {
        exportData.data.CCData =
          await this.api.get('ExportSystemCodeAll', {}).toPromise();
      }

      if (this.Dosage) {
        exportData.data.DosageData =
          await this.api.get('ExportDosageAll', {}).toPromise();
      }

      const json = JSON.stringify(exportData, null, 2);

      const blob = new Blob([json], {
        type: 'application/json;charset=utf-8'
      });

      const fileName =
        UserCache.getLoginUser().Clinic.Id +
        '_匯出資料_' +
        onGetDateString(new Date(), false, '', false) +
        DateHelper.getTimeString(new Date(), '', true) +
        '.json';

      this.hcrService.SaveBlobAs('下載\\' + fileName, blob);

    }
    catch (error) {
      console.error(error);
      this.notification.showWarning('匯出失敗');
    }
    finally {
      this.mainlayout.hideLoader();
    }
  }
  //序列化檢查匯入格式
  isPlainObject(v: unknown): v is Record<string, unknown> {
    return typeof v === 'object' && v !== null && !Array.isArray(v);
  }
  isFiniteNumber(v: unknown): v is number {
    return typeof v === 'number' && Number.isFinite(v);
  }
  isInt(v: unknown): boolean {
    return this.isFiniteNumber(v) && Number.isInteger(v);
  }

  getExactKeyErrors(item: Record<string, unknown>, schema: Record<string, string>, path: string): string[] {
    const actualKeys = Object.keys(item);
    const expectedKeys = Object.keys(schema);
    const missing = expectedKeys.filter(x => !actualKeys.includes(x));
    const extra = actualKeys.filter(x => !expectedKeys.includes(x));
    const errors: string[] = [];

    if (missing.length) errors.push(`${path} 缺少欄位: ${missing.join(', ')}`);
    if (extra.length) errors.push(`${path} 多出欄位: ${extra.join(', ')}`);

    return errors;
  }

  validateValueKind(value: unknown, kind: string): boolean {
    switch (kind) {
      case 'string':
        return typeof value === 'string';
      case 'string?':
        return value === null || typeof value === 'string';
      case 'bool':
        return typeof value === 'boolean';
      case 'boolean?':
        return value === null || typeof value === 'boolean';
      case 'int':
        return this.isInt(value);
      case 'int?':
        return value === null || this.isInt(value);
      case 'decimal?':
      case 'number?':
        return value === null || this.isFiniteNumber(value);
      case 'string[]':
        return Array.isArray(value) && value.every(x => typeof x === 'string');
      default:
        return false;
    }
  }

  validateObjectBySchema(item: unknown, schema: Record<string, string>, path: string): string[] {
    if (!this.isPlainObject(item)) {
      return [`${path} 不是合法物件`];
    }

    const keyErrors = this.getExactKeyErrors(item, schema, path);
    if (keyErrors.length) return keyErrors;

    const errors: string[] = [];
    for (const [key, kind] of Object.entries(schema)) {
      if (!this.validateValueKind(item[key], kind)) {
        errors.push(`${path}.${key} 型別錯誤，預期 ${kind}`);
      }
    }

    return errors;
  }

  validateImportRxItem = (item: unknown, path: string): string[] => {
    return this.validateObjectBySchema(item, RX_FIELDS, path);
  };

  validateImportRxSetItem = (item: unknown, path: string): string[] => {
    return this.validateObjectBySchema(item, RX_SET_FIELDS, path);
  };

  validateImportMainSetItem = (item: unknown, path: string): string[] => {
    if (!this.isPlainObject(item)) {
      return [`${path} 不是合法物件`];
    }

    const keyErrors = this.getExactKeyErrors(item, MAINSET_FIELDS, path);
    if (keyErrors.length) return keyErrors;

    const errors: string[] = [];
    for (const [key, kind] of Object.entries(MAINSET_FIELDS)) {
      const val = item[key];

      if (key === 'RxSetList') {
        if (!Array.isArray(val)) {
          errors.push(`${path}.RxSetList 型別錯誤，預期 rxset[]`);
          continue;
        }

        val.forEach((x, idx) => {
          errors.push(...this.validateImportRxSetItem(x, `${path}.RxSetList[${idx}]`));
        });
        continue;
      }

      if (!this.validateValueKind(val, kind)) {
        errors.push(`${path}.${key} 型別錯誤，預期 ${kind}`);
      }
    }

    return errors;
  };

  validateImportSystemCodeItem = (item: unknown, path: string): string[] => {
    return this.validateObjectBySchema(item, SYSTEMCODE_FIELDS, path);
  };

  validateImportDosageItem = (item: unknown, path: string): string[] => {
    return this.validateObjectBySchema(item, DOSAGE_FIELDS, path);
  };

  collectValidationErrors(
    items: unknown[],
    validator: (item: unknown, path: string) => string[],
    prefix: string
  ): string[] {
    const errors: string[] = [];
    items.forEach((item, index) => {
      errors.push(...validator(item, `${prefix}[${index}]`));
    });
    return errors;
  }
  async onBtnImportfileClick() {
    const input = document.getElementById('fileInput') as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;
    const file = input.files[0];
    const text = await file.text();

    let parsed: unknown;
    try {
      parsed = JSON.parse(text);
    } catch {
      this.notification.showWarning('匯入檔案不是合法 JSON');
      return;
    }

    if (!this.isPlainObject(parsed)) {
      this.notification.showWarning('匯入檔外層格式錯誤');
      return;
    }

    const rootErrors = this.getExactKeyErrors(parsed, { customerCode: 'string', exportTime: 'string', data: 'object' }, 'root');
    if (rootErrors.length) {
      this.notification.showWarning(rootErrors.join('\n'));
      return;
    }

    const rootData = parsed['data'];
    if (!this.isPlainObject(rootData)) {
      this.notification.showWarning('data 欄位格式錯誤');
      return;
    }

    const allowedDataKeys = ['RxData', 'MainSetData', 'CCData', 'DosageData'];
    const extraDataKeys = Object.keys(rootData).filter(k => !allowedDataKeys.includes(k));
    if (extraDataKeys.length) {
      this.notification.showWarning(`data 多出欄位: ${extraDataKeys.join(', ')}`);
      return;
    }

    // 只驗證「實際存在」的表必須是陣列；缺少的表視為未匯出
    for (const key of allowedDataKeys) {
      if (key in rootData && !Array.isArray(rootData[key])) {
        this.notification.showWarning(`data.${key} 型別錯誤，預期 array`);
        return;
      }
    }

    // 至少要有一個表，否則沒有任何資料可匯入
    if (!allowedDataKeys.some(key => Array.isArray(rootData[key]))) {
      this.notification.showWarning('匯入檔案沒有任何可匯入的資料');
      return;
    }

    if (Array.isArray(rootData['RxData'])) {
      const rxErrors = this.collectValidationErrors(rootData['RxData'], this.validateImportRxItem, 'RxData');
      if (rxErrors.length) {
        this.notification.showWarning(rxErrors.join('\n'));
        return;
      }
    }

    if (Array.isArray(rootData['MainSetData'])) {
      const mainSetErrors = this.collectValidationErrors(rootData['MainSetData'], this.validateImportMainSetItem, 'MainSetData');
      if (mainSetErrors.length) {
        this.notification.showWarning(mainSetErrors.join('\n'));
        return;
      }
    }

    if (Array.isArray(rootData['CCData'])) {
      const ccErrors = this.collectValidationErrors(rootData['CCData'], this.validateImportSystemCodeItem, 'CCData');
      if (ccErrors.length) {
        this.notification.showWarning(ccErrors.join('\n'));
        return;
      }
    }

    if (Array.isArray(rootData['DosageData'])) {
      const dosageErrors = this.collectValidationErrors(rootData['DosageData'], this.validateImportDosageItem, 'DosageData');
      if (dosageErrors.length) {
        this.notification.showWarning(dosageErrors.join('\n'));
        return;
      }
    }

    const data = parsed as {
      data: {
        RxData: any[];
        MainSetData: any[];
        CCData: any[];
        DosageData: any[];
      };
    };

    this.ImportRxData = data.data.RxData ?? [];
    this.ImportMainSetData = data.data.MainSetData ?? [];
    this.ImportCCData = data.data.CCData ?? [];
    this.ImportDosageData = data.data.DosageData ?? [];

    this.Rx = this.ImportRxData.length > 0;
    this.MainSet = this.ImportMainSetData.length > 0;
    this.CC = this.ImportCCData.length > 0;
    this.Dosage = this.ImportDosageData.length > 0;
    if (this.Rx) {
      this.WhichImporTableShow = 0;
      this.ShowImportRx = [];

      this.CachedRxData = await this.clinicData.GetRxOption();

      const rxDataMap = new Map<string, RxOpt>();
      for (const item of this.CachedRxData ?? []) {
        if (item?.RxCode) rxDataMap.set(item.RxCode, item);
      }

      for (const item of this.ImportRxData ?? []) {
        const change: RxItem = {
          RxCode: item.RxCode,
          ProdName: item.ProdName,
          StdCode: item.StdCode,
          AlternativeRxCode: item.AlternativeRxCode,
          IsAlive: item.IsAlive,
          Change: '',
        };

        if (item.IsAlive === false) {
          change.Change = '刪除';
        } else if (rxDataMap.has(item.RxCode)) {
          change.Change = '更新';
        } else {
          change.Change = '新增';
        }

        this.ShowImportRx.push(change);
      }
    } else if (this.MainSet) {
      this.WhichImporTableShow = 1;
    } else if (this.CC) {
      this.WhichImporTableShow = 2;
    } else if (this.Dosage) {
      this.WhichImporTableShow = 3;
    }

    //套餐
    if (this.MainSet) {
      // 1) 初始化
      this.ShowImportMainSet = [];

      // 2) 取得快取（你依自己專案實際方法替換）
      // 例如：this.CachedMainSetData = await this.clinicData.GetMainSetOption();
      this.CachedMainSetData = await this.clinicData.GetRsOption()

      // 3) 快取 Map（以 Code 當 key）
      const mainSetMap = new Map<string, any>();
      for (const c of this.CachedMainSetData ?? []) {
        const code = (c?.RsCode ?? '').toString();
        if (code) mainSetMap.set(code, c);
      }

      const importMainSetCodeSet = new Set<string>();
      for (const item of this.ImportMainSetData ?? []) {
        const code = (item?.Code ?? '').toString();
        if (code) importMainSetCodeSet.add(code);
      }

      // 4) 逐筆轉成 ShowImportMainSetData（含攤平 DxApplyCode / RxSetList）
      for (const item of this.ImportMainSetData ?? []) {
        const dxApplyCode = (item.DxApplyCode ?? [])
          .filter((x: string) => !!x && x.trim() !== '')
          .join(', ');

        const rxSetList = (item.RxSetList ?? [])
          .map((r: any) => (r?.RxCode ?? '').toString())
          .filter((x: string) => !!x && x.trim() !== '')
          .join(', ');

        const row: ShowImportMainSetData = {
          Code: item.Code,
          IsAlive: item.IsAlive,
          DxApplyCode: dxApplyCode,
          RxSetList: rxSetList,
          Change: '', // 下面決定
        };

        // Change：先判斷 IsAlive，再判斷 key 是否存在
        if (item.IsAlive === false) {
          row.Change = '刪除';
        } else if (mainSetMap.has(item.Code)) {
          row.Change = '更新';
        } else {
          row.Change = '新增';
        }

        this.ShowImportMainSet.push(row);
      }

      for (const cached of this.CachedMainSetData ?? []) {
        const code = (cached?.RsCode ?? '').toString();
        if (!code || importMainSetCodeSet.has(code)) {
          continue;
        }

        this.ShowImportMainSet.push({
          Code: code,
          IsAlive: false,
          DxApplyCode: '',
          RxSetList: '',
          Change: '刪除',
        });
      }
    }

    this.ImportpageChange(1);
    this.showImportBtnGroup = true;

  }

  ImportpageChange(pageNum: number): void {
    this.pageSkipNo = (pageNum-1)*this.pageSize;
    if(this.WhichImporTableShow == 0){
      this.ImportRxDataView = {pageNumber : pageNum, pageSize : this.pageSize, total : this.ShowImportRx.length, totalPages : Math.ceil(this.ShowImportRx.length / this.pageSize), data : this.ShowImportRx.slice(this.pageSkipNo,this.pageSkipNo + 10)}
    }
    if(this.WhichImporTableShow == 1){
      this.ImportMainSetDataView = {pageNumber : pageNum, pageSize : this.pageSize, total : this.ShowImportMainSet.length, totalPages : Math.ceil(this.ShowImportMainSet.length / this.pageSize), data : this.ShowImportMainSet.slice(this.pageSkipNo,this.pageSkipNo + 10)}
    }
    if(this.WhichImporTableShow == 2){
      this.ImportCCDataView = {pageNumber : pageNum, pageSize : this.pageSize, total : this.ImportCCData.length, totalPages : Math.ceil(this.ImportCCData.length / this.pageSize), data : this.ImportCCData.slice(this.pageSkipNo,this.pageSkipNo + 10)}
    }
    if(this.WhichImporTableShow == 3){
      this.ImportDosageDataView = {pageNumber : pageNum, pageSize : this.pageSize, total : this.ImportDosageData.length, totalPages : Math.ceil(this.ImportDosageData.length / this.pageSize), data : this.ImportDosageData.slice(this.pageSkipNo,this.pageSkipNo + 10)}
    }
  }

  ImportpageReset(){
    this.pageSkipNo = 0;
    this.ImportpageChange(1);
  }

  async onBtnImportAPIClick(){//匯入後端
    this.api = this.webApiClient.createHisService('DebugTool');

    if(this.Dosage){
      this.PostDosage = await this.api.post('PostDosage', this.ImportDosageData).toPromise();
    }
    if(this.Rx){
      this.PostRx = await this.api.post('PostRx', this.ImportRxData).toPromise();
    }
    if(this.MainSet){
      this.PostMainSet = await this.api.post('PostMainSet', this.ImportMainSetData).toPromise();
    }
    if(this.CC){
      this.PostSystemCode = await this.api.post('PostSystemCode', this.ImportCCData).toPromise();
    }
    //this.confirmService.showAlert('執行結果',this.PostDosage + '\n' + this.PostRx + '\n' + this.PostMainSet + '\n' + this.PostSystemCode);
    await this.layout.showCustomConfirm({
      msg: this.PostDosage + '\n' + this.PostRx + '\n' + this.PostMainSet + '\n' + this.PostSystemCode,
      title:'執行結果',
      hideNo:true,
      textYes:'確認',
      focus:true,
      width: 500
    });
  }

  pageChange(pageNum: number): void {
    this.pageSkipNo = (pageNum-1)*this.pageSize;
    if(this.WhichTableShow == 0){
      this.GetRx(this.pageSize,this.pageSkipNo)
    }
    if(this.WhichTableShow == 1){
      this.GetMainSet(this.pageSize,this.pageSkipNo)
    }
    if(this.WhichTableShow == 2){
      this.GetSystemCode(this.pageSize,this.pageSkipNo)
    }
    if(this.WhichTableShow == 3){
      this.GetDosage(this.pageSize,this.pageSkipNo)
    }
  }

  pageReset(){
    this.pageSkipNo = 0;
    this.pageChange(1);
  }

  async releaseLicense(data:UserClient){
    if(!data?.LicenseKey){
      this.notification.showWarning('此設備沒有可釋出的授權碼。');
      return;
    }

    const ok = await this.confirmService.showConfirm({
      title:'釋出授權',
      msg:`確定要釋出 ${data.ComputerName || data.UserName} 的授權嗎？`
    });
    if(!ok){
      return;
    }

    try{
      const result = await this.licenseApi.Release({
        Code: data.ClinicCode,
        LicenseKey: data.LicenseKey
      });

      if(result?.Success){
        data.LicenseKey = '';
        this.notification.showSuccess(result.Message || '授權釋出成功。');
      }else{
        await this.confirmService.showAlert('釋出失敗', result?.Message || '授權釋出失敗。');
      }
    }catch(ex){
      const msg = (ex?.message || ex?.Message || ex || '授權釋出失敗。').toString();
      await this.confirmService.showAlert('釋出失敗', msg);
    }
  }

  displayData(label:string,tip:string,col:keyof CshisIni){
    var data =  this.consoleInfo?.CSHIS[col];
    return {
      label,
      tip,
      value:data==true?'✅':data==false?'❌':data,
      cls:data==true?'text-success':data==false?'text-danger':'text-primary',
    }
  }

  async notifyUser(user:UserClient){
    var ret = await this.ezForm.show({
      title:'請輸入要發送的訊息',
      msg:'請輸入要發送的訊息',
      fields:{
        msg:{
          type:'text',
          name:'msg',
          label:'訊息',
          value:''
        }
      },
      closeValue:()=>null
    })
    var msg = ret?.msg;
    if(msg){
      await this.consoleApi.Notify({
        UserId:user.UserId,
        Message:msg
      })
    }
  }
  /** 全屏開廣 */
  async BroadcaseNotify(){
    var ret = await this.ezForm.show({
      title:'請輸入要發送的訊息',
      msg:'請輸入要發送的訊息',
      fields:{
        msg:{
          type:'text',
          name:'msg',
          label:'訊息',
          value:''
        }
      },
      closeValue:()=>null
    })
    var msg = ret?.msg;
    if(msg){
      await this.consoleApi.NotifyAll(msg);
    }
  }
}


type RxFieldKind = 'string' | 'string?' | 'int' | 'bool' | 'int?' | 'decimal?' | 'datetime?';

const RX_FIELDS: Record<string, RxFieldKind> = {
  // Key / 基本識別
  RxCode: 'string',
  StdCode: 'string',
  ShortNo: 'string',

  // 名稱類
  ProdName: 'string',
  IIName: 'string',
  GXName: 'string',
  ChineseName: 'string',
  IngredientRatio: 'string',

  // 分類 / 型別
  Type: 'int',
  PaymentType: 'string',
  AccSubject: 'string',
  DispTP: 'string',
  DeclRule: 'int?',

  // 狀態旗標
  IsDrugStatus: 'bool',
  IsStock: 'bool',
  IsEnabled: 'bool',
  IsAlive: 'bool',
  IsByOral: 'bool',
  IsPregnantWomen: 'bool',
  IsBreastfeeding: 'bool',
  IsComplex: 'string',
  IsPriorReview: 'bool',
  IsAlternative: 'bool',

  // 價格 / 日期
  PriceChgDate: 'string?',
  IPrice: 'decimal?',
  LastIPrice: 'decimal?',
  Price: 'decimal?',
  DiffPrice: 'decimal?',

  // Additions
  AdditionMAT: 'decimal?',
  AdditionEME: 'decimal?',
  Addition2Y: 'decimal?',
  Addition6Y: 'decimal?',
  AdditionMAG: 'decimal?',
  AdditionSND: 'decimal?',
  Addition6M: 'decimal?',
  AdditionP6M: 'decimal?',
  AdditionP2Y: 'decimal?',
  AdditionP6Y: 'decimal?',

  // 預設劑量 / 用法
  DefaultDose: 'decimal?',
  DefaultDailyDose: 'decimal?',
  DefaultTotalDose: 'decimal?',
  DefaultFrequency: 'string',
  DefaultDays: 'int?',
  DefaultWay: 'string',
  DefaultSurgery: 'string',

  // 管制 / 分類碼
  SPRule: 'int?',
  CTRDrugs: 'string',
  DrugControlNo: 'string',
  ATC: 'string',
  DTP: 'string',

  // 關聯（Id → Code）
  AlternativeRxCode: 'string',
  RelatedRxCode: 'string',
  RelatedRxCodes: 'string',

  // 警示 / 年齡
  AllergyGroup: 'string',
  BelowtheAge: 'int?',
  HigherthanAge: 'int?',
  NumberWarning: 'int?',
  DayWarning: 'int?',
  MonthWarning: 'int?',
  WarningDays: 'int?',
  IntervalDays: 'int?',

  // 劑型 / 用量
  DosageCode: 'string',
  DoseForm: 'string',
  SyrupNote: 'string',
  UseUnit: 'string',

  // 規格 / 包裝
  Spec: 'string',
  SpecAmount: 'decimal?',
  SpecUnit: 'string',
  BoxUnit: 'string',
  DrugsPerBox: 'int?',

  // 檢驗 / 院所
  LabItemCode: 'string',
  LabHosp: 'string',

  // 說明 / 警語
  StorageMethod: 'string',
  ValidityPeriod: 'string',
  Warnings: 'string',
  Indications: 'string',
  SideEffects: 'string',
  OtherInstructions: 'string',
  ClinicalWay: 'string',
  Exterior: 'string',
  ImportantTip: 'string',
  ImportantTipDisplayMethod: 'string',

  // 審查 / 停用日期
  PriorReviewDate: 'string?',
  DrugStopDate: 'string?',

  // 廠商 / 申請者
  ManufacturerName: 'string',
  ApplicantName: 'string',

  // 其他
  ExtendNote: 'string',
  SearchCode1: 'string',
  SearchCode2: 'string',
  SearchCode3: 'string',
  CustomerCost: 'decimal?',
};

type MainSetFieldKind = 'string' | 'bool' | 'string[]' | 'rxset[]';
type RxSetFieldKind = 'string' | 'string?' | 'int' | 'int?' | 'number?' | 'boolean?';

const RX_SET_FIELDS: Record<string, RxSetFieldKind> = {
  RxCode: 'string',
  DosageCode: 'string',

  Classify: 'string?',
  Sort: 'int?',

  PackageNo: 'int?',
  SpecialRule: 'int?',

  Dose: 'number?',
  DailyDose: 'number?',
  TotalDose: 'number?',

  Frequency: 'string?',
  InfoFrequency: 'number?',

  Way: 'string?',
  Days: 'int?',
  InfoDays: 'int?',

  DispTP: 'string?',
  Remark: 'string?',

  IsEnabled: 'boolean?',
  IsAlive: 'boolean?',
};

const MAINSET_FIELDS: Record<string, MainSetFieldKind> = {
  Code: 'string',
  Name: 'string',
  MedDeptCode: 'string',
  IsEnabled: 'bool',
  IsAlive: 'bool',
  DxApplyCode: 'string[]',
  CC: 'string',
  PE: 'string',
  Sur1: 'string',
  Sur2: 'string',
  Sur3: 'string',
  SPTX1: 'string',
  SPTX2: 'string',
  SPTX3: 'string',
  SPTX4: 'string',
  Account: 'string',
  RxSetList: 'rxset[]',
};

type SystemCodeFieldKind = 'string' | 'int' | 'bool';

const SYSTEMCODE_FIELDS: Record<string, SystemCodeFieldKind> = {
  TypeCode: 'string',
  Code: 'string',
  StandardCode: 'string',
  SN: 'int',
  Name: 'string',
  Name1: 'string',
  Name2: 'string',
  Name3: 'string',
  Attribute: 'string',
  IsSuperSye: 'bool',
  IsEnabled: 'bool',
  IsAlive: 'bool',
};

type DosageFieldKind = 'string' | 'bool' | 'int?';

const DOSAGE_FIELDS: Record<string, DosageFieldKind> = {
  SN: 'int?',
  TMDay: 'int?',
  TMQty: 'int?',

  Code: 'string',
  ApplyCode: 'string',
  Name: 'string',
  UsageTime: 'string',
  UsageTimeLTC: 'string',
  Description: 'string',

  IsEnabled: 'bool',
  IsAlive: 'bool',
};


//import匯入資料處存
interface RxItem {
  RxCode: string;
  ProdName: string;
  StdCode: string;
  AlternativeRxCode?: string;
  IsAlive: boolean;
  Change: string;
}

interface RxDataResponse {
  pageNumber: number;
  pageSize: number;
  total: number;
  totalPages: number;
  data: RxItem[];
}

interface RxSetListItem{
  RxCode: string;
  DosageCode: string;
  Sort: number;
}

interface MainSetItem {
  Code: string;
  Name: string;
  IsAlive: boolean;
  DxApplyCode: string[];
  RxSetList: RxSetListItem[];
  Change: string;
}

interface MainSetDataResponse {
  pageNumber: number;
  pageSize: number;
  total: number;
  totalPages: number;
  data: MainSetItem[];
}

interface SystemCodeItem {
  Code: string;
  Name: string;
  IsAlive: boolean;
  Change: string;
}

interface SystemCodeDataResponse {
  pageNumber: number;
  pageSize: number;
  total: number;
  totalPages: number;
  data: SystemCodeItem[];
}

interface DosageItem {
  Code: string,
  Name: string,
  ApplyCode: string,
  TMDay: number,
  TMQty: number,
  IsAlive: true
  Change: string;
}

interface DosageDataResponse {
  pageNumber: number;
  pageSize: number;
  total: number;
  totalPages: number;
  data: DosageItem[];
}
//匯入預覽
interface ShowImportMainSet{
  pageNumber: number;
  pageSize: number;
  total: number;
  totalPages: number;
  data: ShowImportMainSetData[];
}

interface ShowImportMainSetData{
  Code: string;
  IsAlive: boolean;
  DxApplyCode: string;
  RxSetList: string;
  Change: string;
}
//匯出預覽
interface ShowExportMainSet{
  pageNumber: number;
  pageSize: number;
  total: number;
  totalPages: number;
  data: ShowExportMainSetData[];
}
interface ShowExportMainSetData{
  Code: string;
  DxApplyCode: string;
  RxSetList: string;
}





interface LogDetail{
  date: string,
  time: string,
  type: string,
  st  : string,
  msg : string,
 }
 interface LogDetailFilter{
  stime: string,
  etime: string,
  keyword : string,
 }
